var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgStyleseeker = function SvgStyleseeker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Styleseeker_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".Styleseeker_svg__st2{fill-rule:evenodd;clip-rule:evenodd;fill:currentColor}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Styleseeker_svg__Stroke",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Styleseeker_svg__Stroke-Copy",
    d: "M30 0c16.6 0 30 13.4 30 30S46.6 60 30 60 0 46.6 0 30 13.4 0 30 0z",
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-169 9)",
    id: "Styleseeker_svg__SYMBOLS"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Styleseeker_svg__Group-14",
    transform: "translate(169 -9)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Styleseeker_svg__Group-3",
    transform: "translate(23.385 5.846)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Styleseeker_svg__Fill-1",
    d: "M14.3 28.8h12.8c.2-1 .3-2 .3-3 0-4.6-1.8-8.9-4.7-12.1l-8.4 15.1z",
    mask: "url(#Styleseeker_svg__mask-2_1_)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Styleseeker_svg__Fill-4",
    className: "Styleseeker_svg__st2",
    d: "M32.2 13.3c-1.1 0-2.2.1-3.2.3l8.7 15 6.4-11c-3.2-2.7-7.4-4.3-11.9-4.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Styleseeker_svg__Fill-6",
    className: "Styleseeker_svg__st2",
    d: "M27.1 28.2H13.9c-.2 1.1-.3 2.2-.3 3.4 0 4.6 1.8 8.8 4.7 12.1l8.8-15.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Styleseeker_svg__Fill-8",
    className: "Styleseeker_svg__st2",
    d: "M49.8 37.5H32.4l6.2 11.3c5.3-2 9.4-6.1 11.2-11.3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Styleseeker_svg__Fill-10",
    className: "Styleseeker_svg__st2",
    d: "M32.2 49.9c1.2 0 2.3-.1 3.5-.3l-8.6-14.9-6.6 11.1c3.2 2.5 7.3 4.1 11.7 4.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Styleseeker_svg__Fill-12",
    className: "Styleseeker_svg__st2",
    d: "M14.7 25.4h17.7l-6-11.1c-5.5 1.7-9.8 5.9-11.7 11.1"
  })))));
};
export default SvgStyleseeker;